import { render, staticRenderFns } from "./EditFormItem.vue?vue&type=template&id=4896cf05&scoped=true&"
import script from "./EditFormItem.vue?vue&type=script&lang=js&"
export * from "./EditFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896cf05",
  null
  
)

export default component.exports